export function setPersonType( type ){
    return {
        type: "SET_PERSON_TYPE",
        payload: type
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/person-type-component/actions.js